import { render } from "./App.vue?vue&type=template&id=8d6b92bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8d6b92bc&lang=less"

import exportComponent from "/Users/mac/Desktop/JZZP-XIHAIAN/jzzp_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__